import { render, staticRenderFns } from "./RatingUserAnswer.vue?vue&type=template&id=f4fdd3f4&lang=html"
import script from "./RatingUserAnswer.vue?vue&type=script&lang=js"
export * from "./RatingUserAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports